(ns common.schema.entities.survey.survey-question-option
  (:require
   [common.data-types :as data-types]
   [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/text-edn-field :survey-question-option/label-translations
                      "Label"
                      {:authorization su/access-user-sug
                       :default-field-visibility :in-use-disabled})))
